<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-body tab2-card">

                  <div id="loadingScreen" class="loading-screen">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="ml-3 text-primary lead">Se efectueaza anularea<span class="dot dot1">.</span><span class="dot dot2">.</span><span class="dot dot3">.</span></p>
                  </div>

                </div>
            </div>
        </div>
    </div>
